<template>
  <div class="details">
    <Header />
    <Nav />
    <div class="details-nav">
      <div class="details-backimg"></div>
      <div class="details-title">
        <div class="details-title-bread">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>宏云课堂</el-breadcrumb-item>
            <el-breadcrumb-item>全部课程</el-breadcrumb-item>
            <el-breadcrumb-item>课程详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="details-title-btn">
          <span>收藏</span>
          <span>分享</span>
        </div>
      </div>
      <div class="details-bannerconts">
        <div class="details-bannerconts-video">
          <img
            :src="require('../assets/home/list' + this.list.img + '.png')"
            alt=""
          />
          <div class="details-bannerconts-videos">
            <div class="details-bannerconts-videocont" @click="SeeVideo()">
              <img src="../assets/icon/video.png" alt="" />
              <span>免费试学</span>
            </div>
          </div>
        </div>
        <div class="details-bannerconts-cont">
          <p class="details-bannerconts-contp1">
            {{ this.list.title }}
          </p>
          <p class="details-bannerconts-contp2">
            <span>疫情</span>
            <span>政府采购</span>
          </p>
          <p class="details-bannerconts-contp3">
            讲师：&nbsp;<span>{{ this.list.name }}</span
            >&nbsp;&nbsp; 宏云机构&nbsp;&nbsp;
            <span>{{ this.list.classnumber }}</span
            >&nbsp;节课程 &nbsp;&nbsp;<span>{{ this.list.time }}</span
            >&nbsp;小时<span>&nbsp;&nbsp;99%</span>&nbsp;好评
          </p>
        </div>
      </div>
    </div>
    <div class="details-main">
      <div class="details-main-money">
        <div class="details-main-moneyleft">
          <p>￥{{this.list.money}}</p>
          <span>支付保障·课后有回放</span>
        </div>
        <div class="details-main-moneyright">
          <p @click="goCar">立即购买</p>
          <span @click="goCar">加入购物车</span>
        </div>
      </div>
      <div class="details-main-det">
        <div class="details-main-detleft">
          <div class="details-main-dettab">
            <ul>
              <li
                v-for="(item, index) in activelist"
                :key="index"
                @click="jieshao(index)"
                :class="{ active: activeIndex == index }"
              >
                {{ item }}
              </li>
            </ul>
          </div>
          <div class="details-main-dettabCont" v-if="contshow">
            <h4>课程基本信息</h4>
            <div class="details-more">
              <p>
                <span><i></i>课程类型：{{ this.list.classtype }}</span>
                <span><i></i>课程有效时间：{{ this.list.termtime }}</span>
              </p>
              <p>
                <span><i></i>课程节数：{{ this.list.number }}节</span>
                <span><i></i>课程分类：{{ this.list.classmore }}</span>
              </p>
            </div>
            <h4>讲师介绍</h4>
            <div class="details-teacher">
              <ul>
                <li>
                  <div class="details-teacherdiv1">
                    <img :src="require('../assets/icon/tea' + this.list.img + '.png')" alt="" />
                    <div class="details-teacherdiv2">
                      <p>{{ this.list.teacher }}老师</p>
                      <span>资深老师</span>
                    </div>
                    <div class="details-teacherdiv3">
                      <img src="./../assets/icon/info.png" alt="" />
                      <span>更多老师信息</span>
                    </div>
                  </div>
                  <div class="details-teacherdiv4">
                    <p>
                      {{ this.list.teacherinfo }}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <h4>课程详情</h4>
            <div class="details-text">
              <p v-html="this.list.content"></p>
            </div>
            <h4>课程亮点：</h4>
            <div class="details-light">
              <p>
                {{ this.list.light }}
              </p>
            </div>
            <h4>推荐给每一个政府采购从业者，您会从中收获：</h4>
            <div class="details-company">
              <p>
                <span>1、如何判断采购人提出的采购需求是否合法？如何认定技术指标是否具有倾向性、排他性？如何解释招标文件中重要概念的歧义？投标人报价错误应如何进行修正？认定投标文件中的重大负偏离如何把握？评标委员会的评审范围和权限如何界定？对违规供应商的处罚需要考虑哪些情节？等等，这些困扰从业人员的操作性问题，通过对这些案例剥茧抽丝般的分析，一一予以剖析和解答。</span>
                <span>2、既可从中学到理论知识，又能学到如何理论联系实际，解决实践中的问题。</span>
              </p>
            </div>
            <h4>结业考试</h4>
            <div class="details-paper">
              <p>
                考试<span class="spanOne" @click="goexam">考试</span
                >政策考试试卷
              </p>
              <span class="spanTwo" @click="goexam">立即开始</span>
            </div>
          </div>
          <div class="details-main-dettabCont" v-if="!contshow">
            <h4>课程目录</h4>
            <div class="mulu" v-if="mulishow">
              <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item
                  v-for="(item, index) in detList"
                  :key="index"
                  :title="item.name"
                  :name="item.nameid"
                >
                  <div
                    id="mululist"
                    v-for="(value, ind) in item.children"
                    :key="ind"
                    @click="shipin(ind)"
                    :class="{ active: activeInd == ind }"
                  >
                    <div class="mulutext">
                      <span>视频</span>
                      <p>{{ value.name }}</p>
                      <i></i>
                    </div>
                    <el-button type="primary">购买后查看</el-button>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
            <div class="mulu" v-if="!mulishow">
              <div
                id="mululist"
                v-for="(value, ind) in detLists"
                :key="ind"
                @click="shipin(ind)"
                :class="{ active: activeInd == ind }"
              >
                <div class="mulutext">
                  <span>视频</span>
                  <p>{{ value.name }}</p>
                  <i></i>
                </div>
                <el-button type="primary">购买后查看</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="details-main-detright">
          <div class="details-main-detrighttop">
            <div class="details-main-detrighttopbox">
              <img src="./../assets/icon/gb.png" alt="" />
              <div class="details-main-detrighttop2">
                <p>51RGB在线教育</p>
                <span>top3 机构</span>
              </div>
            </div>
            <p class="pp">
              <span>28</span>节课程<span>6.6</span>小时<span>99%</span>好评
            </p>
            <p class="pp2">
              51RGB
              专业生产高品质课程的在线教育机构，帮助你学软件、设计、创新技能，重建新的就业方向
              & 自主创业。我们也提供高品质免费教程 & 免费在线课程。
              老师（名师介绍）是来自4A广告,CCTV,IBM等大型互联网公司的在职者，在这里跟你分享高端、前沿、实用的专业知识和经验方法。
            </p>
          </div>
          <div class="details-main-detrightbottom">
            <div class="details-main-detrightbottomh2">
              <h3>推荐课程</h3>
              <p>查看更多<span></span></p>
            </div>
            <div class="details-main-detrightbottombox">
              <ul>
                <li>
                  <div class="div1">
                    <img src="./../assets/class/class1.png" alt="" />
                  </div>
                  <div class="div2">
                    <p class="divp1">
                      国有企业采购全流程风险控制与热点问题解析系列课程
                    </p>
                    <p class="divp2">讲师：宏云机构</p>
                    <p class="divp3">￥399</p>
                  </div>
                </li>
                <li>
                  <div class="div1">
                    <img src="./../assets/class/class2.png" alt="" />
                  </div>
                  <div class="div2">
                    <p class="divp1">国有企业招标采购专业实务及案例分析</p>
                    <p class="divp2">讲师：宏云机构</p>
                    <p class="divp3">￥399</p>
                  </div>
                </li>
                <li>
                  <div class="div1">
                    <img src="./../assets/class/class3.png" alt="" />
                  </div>
                  <div class="div2">
                    <p class="divp1">
                      国有企业采购管理规范、招标采购操作实务及采购文件示范文本使用指南
                    </p>
                    <p class="divp2">讲师：宏云机构</p>
                    <p class="divp3">￥399</p>
                  </div>
                </li>
                <li>
                  <div class="div1">
                    <img src="./../assets/class/class4.png" alt="" />
                  </div>
                  <div class="div2">
                    <p class="divp1">【精品在线课程】招标采购基础能力提升</p>
                    <p class="divp2">讲师：宏云机构</p>
                    <p class="divp3">￥399</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleDialogClose"
      center
    >
      <video
        controls
        autoplay
        width="100%"
        height="50%"
        poster="video/pic.png"
        ref="vueRef"
      >
        <source :src="this.list.video" />
      </video>
    </el-dialog>
    <Fixed/>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import menuList from "@/assets/data/typeLeave.js";
import Nav from "@/components/Nav.vue";
import classList from "@/assets/data/classdetail.js";
import detailList from "@/assets/data/listdetail.js";
import Fixed from '@/components/Fixed.vue';

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    Nav,
    Fixed,
  },
  data() {
    return {
      menuList,
      classList,
      detailList,
      centerDialogVisible: false,
      // videoUrl: "./../assets/icon/1.2 合同管理工作必备法律基础.mp4",
      contshow: true,
      list: [],
      activelist: ["课程介绍", "课程目录"],
      activeIndex: 0,
      activeNames: ["1"],
      detList: [],
      detLists: [],
      activeInd: 0,
      mulishow: true,
    };
  },
  created() {
    console.log(menuList);
    console.log(this.$route.query.id);
    if (this.$route.query.id) {
      this.list = classList[this.$route.query.id - 1];
      console.log(detailList[this.$route.query.id - 1].id);
      if (detailList[this.$route.query.id - 1].id == 2) {
        this.mulishow = false;
        this.detLists = detailList[this.$route.query.id - 1].list;
      } else {
        this.mulishow = true;
        this.detList = detailList[this.$route.query.id - 1].list;
      }
    }
    // console.log(this.list);
    console.log(this.detList);
  },
  mounted() {
    // if (centerDialogVisible == false) {
    //   this.$refs.vueRef.pause();
    // }
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },
    jieshao(index) {
      if (index == 0) {
        this.contshow = true;
        this.activeIndex = index;
      } else {
        this.contshow = false;
        this.activeIndex = index;
      }
    },
    // shipin(ind){
    //   this.activeInd = ind
    // },
    goexam() {
      this.$router.push("/exam");
    },
    goCar() {
      this.$router.push("/car");
    },
    SeeVideo() {
      this.centerDialogVisible = true;
      this.$refs.vueRef.play();
    },
    // 预览视频
    // SeeVideo(){
    //  this.viewVideo = true
    //  this.$refs.vueRef.play();//播放
    // },

    // // 取消预览
    handleDialogClose(e) {
      this.centerDialogVisible = false;
      this.$refs.vueRef.pause(); //暂停
    },
    gopaper() {
      location.href = "";
    },
  },
};
</script>

<style lang="less" scoped>
.details {
  background: #f4f7f9;
  padding-bottom: 20px;
  &-tab {
    width: 1300px;
    height: 22px;
    margin: 0 auto;
    padding: 9px 0 17px;
    text-align: right;
    &-container {
      display: inline-block;
    }
    li {
      display: inline-block;
      margin-left: 72px;
      a {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
      }
    }
  }
  &-nav {
    width: 100%;
    height: 400px;
    position: relative;
    overflow: hidden;
  }
  &-backimg {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("./.././assets/icon/details.png");
    background-position: 50%;
    background-color: hsla(0, 0%, 100%, 0.9);
    background-size: cover;
    -webkit-filter: blur(96px);
    filter: blur(96px);
    opacity: 0.3;
  }
  &-title {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: calc(0 + 2);
    padding: 17px 0px;
    &-bread {
      ul {
        display: flex;
        justify-content: flex-start;
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #666666;
        height: 44px;
      }
      li {
        text-align: center;
        line-height: 44px;
      }
      i {
        display: inline-block;
        padding: 0 2px;
        line-height: 44px;
        font-style: normal;
      }
    }
    &-btn {
      cursor: pointer;
      span {
        display: inline-block;
        width: 70px;
        height: 36px;
        background: #f6f8fb !important;
        border-radius: 18px;
        line-height: 36px;
        text-align: center;
        font-size: 14px;
        font-family: PingFangHK-Semibold, PingFangHK;
        font-weight: 600;
        color: #000000;
        margin: 4px 31px 4px 0px;
      }
    }
  }
  &-bannerconts {
    width: 1300px;
    height: 226px;
    margin: 26px auto 0px auto;
    display: flex;
    justify-content: flex-start;
    position: relative;
    &-video {
      width: 400px;
      height: 226px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0px;
        left: 0px;
        transform: translate(0%, 0%);
      }
    }
    &-videos {
      width: 144px;
      height: 56px;
      background: rgba(0, 0, 0, 0.62);
      border-radius: 28px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &-videocont {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-around;
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
        margin: 20px 23px 20px 20px;
      }
      span {
        display: inline-block;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 56px;
        margin-left: 17px;
      }
    }
    &-cont {
      width: 773px;
      margin-left: 27px;
    }
    &-contp1 {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #202429;
      line-height: 44px;
      padding-left: 15px;
    }
    &-contp2 {
      span {
        display: inline-block;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 20px;
        background: #fafafa;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        margin-top: 10px;
        margin-left: 15px;
        padding: 0 8px;
      }
    }
    &-contp3 {
      margin-top: 19px;
      margin-left: 15px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      span {
        color: #0f1419;
      }
    }
  }
  &-main {
    width: 1300px;
    margin: 0 auto 20px auto;
    position: relative;
    &-money {
      width: 100%;
      height: 110px;
      background: url("./../assets/icon/money.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: space-between;
      position: absolute;
      top: -55px;
    }
    &-moneyleft {
      display: flex;
      justify-content: flex-start;
      p {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ff7a38;
        line-height: 110px;
        margin-left: 25px;
      }
      span {
        display: inline-block;
        height: 20px;
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        border-left: 1px solid #999999;
        padding: 0px 10px;
        margin-top: 45px;
        margin-left: 22px;
      }
    }
    &-moneyright {
      width: 310px;
      height: 48px;
      display: flex;
      justify-content: space-between;
      margin-top: 29px;
      margin-right: 42px;
      cursor: pointer;
      p {
        background-color: #ff7a38;
        border-radius: 24px;
        line-height: 48px;
        padding: 0 30px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
      span {
        background-color: #fad6c4;
        border-radius: 24px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ff7a38;
        line-height: 48px;
        padding: 0 20px;
        color: #ff7a38 !important;
      }
    }
    &-det {
      padding-top: 93px;
      display: flex;
      justify-content: space-between;
    }
    &-detleft {
      width: 877px;
      background: #ffffff;
      border-radius: 3px;
      border: 1px solid #eeeeee;
      padding-bottom: 20px;
    }
    &-dettab {
      height: 68px;
      border-bottom: 1px solid #eeeeee;
      cursor: pointer;
      ul {
        font-size: 23px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        display: flex;
        justify-content: flex-start;
      }
      li {
        line-height: 67px;
        margin: 0 38px;
      }
      li.active {
        border-bottom: 2px solid #ff7a38;
      }
    }
    &-dettabCont {
      padding: 0 40px;
      h4 {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #202429;
        line-height: 25px;
        margin: 20px 0px;
      }
    }
    &-detright {
      width: 400px;
    }
    &-detrighttopbox {
      display: flex;
      justify-content: flex-start;
    }
    &-detrighttop {
      width: 100%;
      height: 326px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #eeeeee;
      box-shadow: 0px 30px 20px -21px #f9ac88 inset;

      img {
        width: 64px;
        height: 64px;
        margin: 13px 0px 0px 28px;
      }
    }
    &-detrighttop2 {
      margin-left: 18px;
      margin-top: 13px;
      p {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3e414d;
        line-height: 25px;
      }
      span {
        display: inline-block;
        background: #f49873;
        border-radius: 10px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 17px;
        padding: 0 10px;
        margin-top: 20px;
      }
    }
    .pp {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5e5c5c;
      line-height: 20px;
      span {
        display: inline-block;
        color: #0f1419;
        margin-top: 27px;
        margin-left: 52px;
      }
    }
    .pp2 {
      width: 360px;
      margin: 25px auto;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #586470;
      line-height: 22px;
    }
    &-detrightbottom {
      width: 100%;
      background: #ffffff;
      border-radius: 7px;
      border: 1px solid #eeeeee;
      padding: 0px 35px 10px 18px;
      box-sizing: border-box;
      margin-top: 20px;
    }
    &-detrightbottomh2 {
      height: 28px;
      display: flex;
      justify-content: space-between;
      margin-top: 31px;
      h2 {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #202429;
        line-height: 28px;
      }
      p {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 28px;
        cursor: pointer;
      }
      span {
        width: 16px;
        height: 16px;
        display: inline-block;
        background: url("./../assets/icon/right-gray.svg") no-repeat 0px 3px;
        background-size: 16px 16px;
      }
    }
    &-detrightbottombox {
      ul {
      }
      li {
        display: flex;
        justify-content: space-between;
        margin-top: 18px;
      }
    }
    .div1 {
      width: 158px;
      height: 89px;
      border-radius: 4px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .div2 {
      margin-left: 11px;
      flex: 1;
    }
    .divp1 {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #586470;
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical; /* 表示盒子对象的子元素的排列方式 */
      -webkit-line-clamp: 2; /* 限制文本的行数，表示文本第多少行省略 */
      text-overflow: ellipsis; /*  打点展示 */
      overflow: hidden; /*超出部分进行隐藏*/
    }
    .divp2 {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 19px;
      margin-top: 5px;
    }
    .divp3 {
      ont-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ff7a38;
      line-height: 20px;
      margin-top: 5px;
    }
  }
  &-more {
    p {
      display: flex;
      justify-content: flex-start;
      margin-top: 15px;
    }
    i {
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #a1a5b2;
      border-radius: 3px;
      font-style: normal;
      line-height: 20px;
      margin-right: 8px;
    }
    span {
      width: 390px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #586470;
      line-height: 20px;
    }
  }
  &-teacher {
    ul {
      display: flex;
      justify-content: space-between;
    }
    li {
      width: 380px;
      height: 207px;
      background: #f5f8fa;
      border-radius: 9px;
      img {
        width: 56px;
        height: 56px;
        border-radius: 28px;
        margin: 26px 0px 0px 19px;
      }
    }
  }
  &-teacherdiv1 {
    height: 101px;
    border-bottom: 1px solid #e9e9e9;
    display: flex;
    justify-content: flex-start;
  }
  &-teacherdiv2 {
    margin-left: 16px;
    p {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3e414d;
      margin-top: 32px;
    }
    span {
      display: inline-block;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666c80;
      margin-top: 4px;
    }
  }
  &-teacherdiv3 {
    margin-top: 32px;
    margin-left: 13px;
    img {
      width: 13px !important;
      height: 13px !important;
      margin: 0px !important;
    }
    span {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666c80;
      margin-left: 2px;
      cursor: pointer;
      line-height: 13px;
    }
  }
  &-teacherdiv4 {
    padding: 16px 24px;
    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #586470;
      line-height: 24px;
      display: -webkit-box;
      -webkit-box-orient: vertical; /* 表示盒子对象的子元素的排列方式 */
      -webkit-line-clamp: 3; /* 限制文本的行数，表示文本第多少行省略 */
      text-overflow: ellipsis; /*  打点展示 */
      overflow: hidden; /*超出部分进行隐藏*/
    }
  }
  &-text {
    max-height: 589px;
    min-height: 300px;
    background: #f5f8fa;
    position: relative;
    overflow-y: auto;
    p {
      position: absolute;
      top: 0px;
      left: 0px;
      padding: 16px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666c80;
      line-height: 25px;
    }
    span {
      display: block;
      word-wrap: break-word;
      word-break: normal;
      margin-bottom: 20px;
    }
  }
  &-text::-webkit-scrollbar {
    width: 4px;
  }
  &-text::-webkit-scrollbar-track {
    background-color: #ccc;
  }
  &-text::-webkit-scrollbar-thumb {
    background-color: #666;
  }
  &-light {
    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666c80;
      line-height: 25px;
    }
  }
  &-company {
    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666c80;
      line-height: 25px;
    }
    span {
      display: block;
      word-wrap: break-word;
      word-break: normal;
      margin-bottom: 4px;
    }
  }
  &-paper {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    display: flex;
    justify-content: space-between;
  }
  .spanOne {
    padding: 0 5px;
    border: 1px solid #333333;
    margin: 0px 40px;
  }
  .spanTwo {
    display: inline-block;
    cursor: pointer;
  }
  .mulu {
    line-height: 25px;
    color: #586470;
  }
  .el-breadcrumb__item {
    line-height: 44px;
  }
  #mululist {
    display: flex;
    justify-content: space-between;
    height: 64px;
    line-height: 64px;
    padding: 0 10px;
    .el-button--primary {
      width: 96px;
      height: 28px;
      background: linear-gradient(90deg, #fd441f 0%, #e1251b 100%);
      border-radius: 2px;
      border: 1px solid #e1251b;
      line-height: 28px;
      text-align: center;
      padding: 0;
      margin-top: 19px;
      display: none;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
  #mululist:hover {
    background: rgba(255, 126, 32, 0.08);
    .el-button--primary {
      display: block;
    }
  }
  .mulutext {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      display: inline-block;
      width: 50px;
      height: 19px;
      background: #ffffff;
      border-radius: 3px;
      border: 1px solid #cccccc;
      text-align: center;
      line-height: 19px;
    }
    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      margin-left: 10px;
      width: 600px;
      display: -webkit-box;
      -webkit-box-orient: vertical; /* 表示盒子对象的子元素的排列方式 */
      -webkit-line-clamp: 1; /* 限制文本的行数，表示文本第多少行省略 */
      text-overflow: ellipsis; /*  打点展示 */
      overflow: hidden; /*超出部分进行隐藏*/
    }
    i {
      width: 16px;
      height: 16px;
      display: inline-block;
      background: url("./../assets/icon/suoding.svg") no-repeat;
      background-size: 16px 16px;
      margin-left: 10px;
    }
  }
  /deep/.el-collapse-item__header {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #353535;
    border: 0px !important;
  }
  /deep/.el-collapse-item__header.is-active {
    color: #ff7a38 !important;
  }
  /deep/.el-collapse {
    border: 0px !important;
  }
  /deep/.el-collapse-item__wrap{
    border: 0px !important;
  }
}
</style>
